var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "55px",
    viewBox: "0 0 65 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Loading/Table") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "9.62219557%",
    y1: "15.2777778%",
    x2: "72.9278826%",
    y2: "70.8993476%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626263",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F31",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "No-Data->-Loading-Widgets",
    transform: "translate(-594.000000, -1127.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M607.541667,1170.33333 L607.541667,1181.16667 L595,1181.16667 C594.447715,1181.16667 594,1180.71895 594,1180.16667 L594,1171.33333 C594,1170.78105 594.447715,1170.33333 595,1170.33333 L607.541667,1170.33333 Z M658,1170.33333 C658.552285,1170.33333 659,1170.78105 659,1171.33333 L659,1180.16667 C659,1180.71895 658.552285,1181.16667 658,1181.16667 L615.666667,1181.16667 L615.666667,1170.33333 L658,1170.33333 Z M607.541667,1148.66667 L607.541667,1159.5 L595,1159.5 C594.447715,1159.5 594,1159.05228 594,1158.5 L594,1149.66667 C594,1149.11438 594.447715,1148.66667 595,1148.66667 L607.541667,1148.66667 Z M658,1148.66667 C658.552285,1148.66667 659,1149.11438 659,1149.66667 L659,1158.5 C659,1159.05228 658.552285,1159.5 658,1159.5 L615.666667,1159.5 L615.666667,1148.66667 L658,1148.66667 Z M607.541667,1127 L607.541667,1137.83333 L595,1137.83333 C594.447715,1137.83333 594,1137.38562 594,1136.83333 L594,1128 C594,1127.44772 594.447715,1127 595,1127 L607.541667,1127 Z M658,1127 C658.552285,1127 659,1127.44772 659,1128 L659,1136.83333 C659,1137.38562 658.552285,1137.83333 658,1137.83333 L615.666667,1137.83333 L615.666667,1127 L658,1127 Z",
    id: "Loading/Table"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "0.5s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTable);
export default __webpack_public_path__ + "static/media/icon-table.853fc35f94f8763d87f4393565bc0af6.svg";
export { ForwardRef as ReactComponent };